import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconType } from '../../models/settings.model';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  standalone: false,
})
export class ModalConfirmComponent implements OnInit {
  @Input() showModalConfirm!: boolean;
  @Input() type?: IconType;
  @Input() modalTitle!: string;
  @Input() notifyText!: string;
  @Input() cancelBtnText!: string;
  @Input() secondaryBtnText!: string;
  @Input() primaryBtnText!: string;
  @Input() modalName?: string;

  @Output() closeModalConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryActionConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() primaryActionConfirm: EventEmitter<any> = new EventEmitter<any>();

  hasSecondaryActionBtn: boolean = false;

  ngOnInit(): void {
    this.hasSecondaryActionBtn = !!this.secondaryBtnText; 
  }

  cancelOnClick(): void {
    this.closeModalConfirm.emit();
  }

  secondaryActionOnClick(): void {
    this.secondaryActionConfirm.emit();
    this.closeModalConfirm.emit();
  }

  primaryActionOnClick(): void {
    this.primaryActionConfirm.emit();
    this.closeModalConfirm.emit();
  }
}
